export default __webpack_public_path__ + "static/media/1806.0de1b27a.png";